export default "__VITE_ASSET__KKwjT3Z6__"